import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { FaCamera } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function ProfileDetails() {
  const [profile, setProfile] = useState(null);
  const { t, i18n } = useTranslation("global")
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [userData, setUserData] = useState(() => {
    const storedUserData = localStorage.getItem("userDataLogin");
    return storedUserData ? JSON.parse(storedUserData) : null;
  });
  const token = userData?.token;

  const [updatedProfile, setUpdatedProfile] = useState({
    name: "",
    email: "",
    birthdate: "",
    image: null,
    imagePreview: "",
    grade_id: "",
    stage_id: "",
  });

  const [grades, setGrades] = useState([]);
  const [stages, setStages] = useState([]);
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const fetchProfile = async () => {
    const userData = JSON.parse(localStorage.getItem("userDataLogin"));
    if (!userData || !userData.token) {
      toast.error("User not authenticated");
      return;
    }

    try {
      const profileResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/profile`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
             "Accept-Language": i18n.language,  // استخدم اللغة من i18n
          },
        }
      );
      

      const profileResult = await profileResponse.json();
      if (profileResult && profileResult.data) {
        setProfile(profileResult.data);
        setUpdatedProfile({
          name: profileResult.data.name || "",
          email: profileResult.data.email || "",
          birthdate: profileResult.data.birthdate || "",
          grade_id: String(profileResult.data.grade_id || ""),
          stage_id: String(profileResult.data.stage_id || ""),
          imagePreview: profileResult.data.imageUrl || "",
        });
      } else {
        toast.error(profileResult.message || "Error fetching profile.");
      }

      const gradesResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/grades`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
      
      const gradesResult = await gradesResponse.json();
      if (gradesResult && gradesResult.data) {
        setGrades(gradesResult.data);
      }

      const stagesResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/stages`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
      
      const stagesResult = await stagesResponse.json();
      if (stagesResult && stagesResult.data) {
        setStages(stagesResult.data);
      }
    } catch (err) {
      toast.error("Server error.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const handleProfileUpdate = async () => {
    const userData = JSON.parse(localStorage.getItem("userDataLogin"));
    if (!userData || !userData.token) {
      toast.error("User not authenticated");
      return;
    }

    const formData = new FormData();
    formData.append("name", updatedProfile.name);
    formData.append("birthdate", updatedProfile.birthdate);

    if (updatedProfile.email !== profile.email) {
      formData.append("email", updatedProfile.email);
    }

    if (updatedProfile.grade_id !== String(profile.grade_id)) {
      formData.append("grade_id", updatedProfile.grade_id);
    }

    if (updatedProfile.stage_id !== String(profile.stage_id)) {
      formData.append("stage_id", updatedProfile.stage_id);
    }

    if (updatedProfile.image) {
      formData.append("image", updatedProfile.image);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/profile`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
          body: formData,
        }
      );
      

      const result = await response.json();
      if (response.ok) {
        toast.success("Profile updated successfully!");
        setProfile(result.data);
        setUpdatedProfile({
          name: result.data.name || "",
          email: result.data.email || "",
          birthdate: result.data.birthdate || "",
          grade_id: String(result.data.grade_id || ""),
          stage_id: String(result.data.stage_id || ""),
          imagePreview: result.data.imageUrl || "",
        });

        const updatedUserData = {
          ...userData,
          user: {
            ...userData.user,
            name: result.data.name || userData.user.name,
            email: result.data.email || userData.user.email,
            image: result.data.image || userData.user.image,
            birthdate: result.data.birthdate || userData.user.birthdate,
            grade_id: result.data.grade_id || userData.user.grade_id,
            stage_id: result.data.stage_id || userData.user.stage_id,
          },
        };

        setUserData(updatedUserData);
        localStorage.setItem("userDataLogin", JSON.stringify(updatedUserData));
      } else {
        toast.error(result.message || "Failed to update profile.");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleCardClick = async (course) => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/payment_course/${course.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      

      const result = await response.json();

      if (course.type === "free") {
        if (result?.code === 200 || result?.status === 200) {
          navigate(`/CourseDetails/${course.id}`);
          toast.success(result.message || "تم عرض  الكورس المجاني بنجاح");
        } else {
          toast.error(result.message || "فشل عرض الكورس المجاني");
        }
      } else if (course.type === "paid") {
        if (course.purshed !== 1) {
          if (result?.redirect_url) {
            window.location.href = result.redirect_url;
          } else {
            toast.error(result.message || "فشل بدء الدفع للكورس المدفوع");
          }
        } else {
          navigate(`/CourseDetails/${course.id}`);
          toast.success("تم عرض الكورس المدفوع بنجاح");
        }
      }
    } catch (error) {
      toast.error("حدث خطأ أثناء محاولة الاشتراك في الكورس");
      console.error(error);
    }
  };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setUpdatedProfile({
        ...updatedProfile,
        image: file,
        imagePreview: imageUrl,
      });
    }
  };

  const handleChangePassword = async () => {
    const userData = JSON.parse(localStorage.getItem("userDataLogin"));

    if (!newPassword || !confirmPassword) {
      toast.error("Please fill in both password fields.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/change-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
          body: JSON.stringify({
            email: profile.email,
            password: newPassword,
            password_confirmation: confirmPassword,
          }),
        }
      );
      

      const result = await response.json();

      if (response.ok) {
        toast.success("Password updated successfully!");
        setShowPasswordFields(false);
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error(result.message || "Failed to update password.");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!profile) return <div>Error loading profile</div>;

  return (
<>
  <ToastContainer />
  <div className="custom-section">
    <div className="container">
      <h1 className="mb-4 text-center text-md-start">
        {profile.name} {t("profile2")}
      </h1>
      <h6 className="m-0 text-center text-md-start">
        <Link className="link-hover" to="/">
          {t("home")}
        </Link>
        <span> - </span>
        <span className="link-hover">{t("yourProfile")}</span>
        <span> - </span>
        <span className="second-color">{t("profileDetails")}</span>
      </h6>
    </div>
  </div>

  <div className="container my-4">
    <div
      style={{ backgroundColor: "#FCF8F8", borderRadius: "10px" }}
      className="row p-3"
    >
      <div
        className="d-flex align-items-center gap-2 position-relative"
        style={{ width: "200px" }}
      >
        <img
          style={{ width: "200px", height: "200px", borderRadius: "50%" }}
          src={
            updatedProfile.imagePreview ||
            profile?.image ||
            "https://static.vecteezy.com/system/resources/thumbnails/026/911/382/small_2x/happy-student-boy-with-books-isolated-free-photo.jpg"
          }
          alt="Profile"
        />
        <label
          className="position-absolute"
          style={{
            bottom: "10px",
            right: "10px",
            backgroundColor: "#fff",
            borderRadius: "50%",
            padding: "10px",
            cursor: "pointer",
          }}
        >
          <FaCamera />
          <input
            type="file"
            className="d-none"
            accept="image/*"
            onChange={handleImageChange}
          />
        </label>
      </div>

      <div className="gap-3 mt-3">
        <p>{t("name")} : {profile.name}</p>
        <p>{t("currentStage")} : {profile.stage_id}</p>
        <p>{t("currentGrade")} : {profile.grade_id}</p>
        <p>{t("studentCode")} : {profile.code_student}</p>
      </div>

      <div className="col-md-12 mb-2 mt-1">
        <label>{t("name")}</label>
        <input
          type="text"
          className="form-control mt-1 py-2"
          value={updatedProfile.name}
          onChange={(e) =>
            setUpdatedProfile({ ...updatedProfile, name: e.target.value })
          }
        />
      </div>

      <div className="col-md-12 mb-2">
        <label>{t("email")}</label>
        <input
          type="email"
          className="form-control mt-1 py-2"
          value={updatedProfile.email}
          onChange={(e) =>
            setUpdatedProfile({ ...updatedProfile, email: e.target.value })
          }
        />
      </div>

      <div className="col-md-12 mb-2">
        <label>{t("birthOfYear")}</label>
        <input
          type="date"
          className="form-control mt-1 py-2"
          value={updatedProfile.birthdate}
          onChange={(e) =>
            setUpdatedProfile({
              ...updatedProfile,
              birthdate: e.target.value,
            })
          }
        />
      </div>

      <div className="col-md-12 mb-2">
        <label>{t("grade")}</label>
        <select
          className="form-control mt-1 py-2"
          value={updatedProfile.grade_id}
          onChange={(e) =>
            setUpdatedProfile({
              ...updatedProfile,
              grade_id: e.target.value,
            })
          }
        >
          {grades.map((grade) => (
            <option key={grade.id} value={String(grade.id)}>
              {grade.name}
            </option>
          ))}
        </select>
      </div>

      <div className="col-md-12 mb-2">
        <label>{t("stage")}</label>
        <select
          className="form-control mt-1 py-2"
          value={updatedProfile.stage_id}
          onChange={(e) =>
            setUpdatedProfile({
              ...updatedProfile,
              stage_id: e.target.value,
            })
          }
        >
          {stages.map((stage) => (
            <option key={stage.id} value={String(stage.id)}>
              {stage.name}
            </option>
          ))}
        </select>
      </div>

      <button
        className="btn w-100 my-2"
        style={{ background: "#0a1056", color: "white" }}
        onClick={handleProfileUpdate}
      >
        {t("saveChanges")}
      </button>

      <div className="mt-4">
        <p
          style={{
            color: "#0d6efd",
            cursor: "pointer",
          }}
          onClick={() => setShowPasswordFields(!showPasswordFields)}
        >
          {t("changePassword2")}
        </p>
      </div>

      {showPasswordFields && (
        <div className="mt-0">
          <div className="mb-2">
            <label>{t("newPassword")}</label>
            <input
              type="password"
              className="form-control"
              placeholder={t("enterNewPassword")}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <div className="mb-2">
            <label>{t("confirmPassword")}</label>
            <input
              type="password"
              className="form-control"
              placeholder={t("confirmNewPassword")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <button
            className="btn my-3 btn-success d-flex justify-content-center mx-auto"
            style={{ color: "white", width: "160px", maxWidth: "100%" }}
            onClick={handleChangePassword}
          >
            {t("save")}
          </button>
        </div>
      )}
    </div>

    <div className="row my-3">
      {profile?.courses?.length > 0 &&
        profile.courses.map((course, index) => {
          const courseImages = JSON.parse(course.image || "[]");
          const courseImageUrl = courseImages.length > 0 ? courseImages[0] : "";
          const instructor = course.instructors && course.instructors.length > 0 ? course.instructors[0] : null;

          return (
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={course.id || index}>
              <div
                onClick={() => handleCardClick(course)}
                style={{ cursor: "pointer" }}
                className="card custom-card h-100"
              >
                <img src={courseImageUrl} alt="Course" className="card-img" />
                <div className="card-body">
                  <div className="card-info">
                    <span>
                      <i className="bi bi-journal-text paragraph-color me-2"></i>
                      {course.lessons} {t("onlineCourses2.lessons")}
                    </span>
                  </div>
                  <h3 className="card-title">{course.name}</h3>

                  {instructor && (
                    <div className="card-instructor">
                      <img src={instructor.image} alt={instructor.name} />
                      <span>{instructor.name}</span>
                    </div>
                  )}

                  <div className="card-footer">
                    <span className="price">
                      {course.type === "free" ? t("free") : course.price}
                    </span>
                    <span className="details">
                      {course.type === "free"
                        ? t("join")
                        : course.purshed === 1
                        ? t("join")
                        : t("subscribe")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  </div>
</>

  );
}
